import { __assign, __extends } from "tslib";
import React from 'react';
import { GalleryContext } from '../context/GalleryContext.js';
var GalleryComponent = /** @class */ (function (_super) {
    __extends(GalleryComponent, _super);
    function GalleryComponent(props) {
        var _this = _super.call(this, props) || this;
        if (typeof _this.context !== 'object') {
            _this.context = {};
        }
        if (props && typeof props.context === 'object') {
            _this.context = __assign(__assign({}, _this.context), props.context);
        }
        return _this;
    }
    GalleryComponent.contextType = GalleryContext;
    return GalleryComponent;
}(React.Component));
export { GalleryComponent };
//# sourceMappingURL=galleryComponent.js.map